"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UrlService = void 0;
const services_definitions_1 = require("@wix/services-definitions");
const signals_1 = require("@wix/services-definitions/core-services/signals");
const definition_1 = require("../definition");
const createUrlService_1 = require("../createUrlService");
exports.UrlService = (0, services_definitions_1.implementService)(definition_1.UrlDefinition, ({ config, getService }) => {
    const signalsService = getService(signals_1.SignalsServiceDefinition);
    const urlServiceApi = (0, createUrlService_1.createUrlService)(config, getService);
    // state refs
    const currentUrl = signalsService.signal(urlServiceApi.getFullUrlWithoutQueryParams());
    const currentUrlWithQueryParams = signalsService.signal(urlServiceApi.getCurrentUrl());
    const relativeUrl = signalsService.signal(urlServiceApi.getRelativeUrl());
    const pushUrlState = (parsedUrl, navigationParams = {}) => {
        urlServiceApi.pushUrl(parsedUrl, navigationParams);
        currentUrl.set(urlServiceApi.getFullUrlWithoutQueryParams());
        currentUrlWithQueryParams.set(urlServiceApi.getCurrentUrl());
        relativeUrl.set(urlServiceApi.getRelativeUrl());
    };
    return {
        ...urlServiceApi,
        pushUrlState,
        // state refs
        getCurrentUrl: () => currentUrl.get(),
        getCurrentUrlWithQueryParams: () => currentUrlWithQueryParams.get(),
        getRelativeUrl: () => relativeUrl.get(),
    };
});
//# sourceMappingURL=urlService.js.map